import VisualizationProvider from "../provider/VizualizationProvider";
import { SET_CONTRIES_VISUALIZATION, SET_DATA_VISUALIZATION, SET_DATA_CONSENSUS_VARIABLE } from "./VizualizationMutationTypes";
import apolloClient from "@/apollo";


export default {
    state: {
        contries_vizualization: [],
        dataVizualization: "[]",
        variable_Visualiztion: [],
    },
    getters: {
        getcontriesVizualization: (state) => {
            return state.contries_vizualization;
        },
        getdataVizualization: (state) => {
            return state.dataVizualization;
        },
        getVariableVisualization: (state) => {
            return state.variable_Visualiztion;
        },
    },
    actions: {
        setCountriesVisualization({ commit }) {
            VisualizationProvider.getCountriesVisualization().then((data) => {
                commit(SET_CONTRIES_VISUALIZATION, data.data.country);
            })
        },
        setDataVisualization({ commit }, data) {
            apolloClient.cache.reset()
            VisualizationProvider.gerData(data[0], data[1]).then((data) => {
                commit(SET_DATA_VISUALIZATION, data.data.visualization.data.replaceAll("\\", ""));
            })
        },
        setVariableVisualizatoin({ commit }, id) {
            apolloClient.cache.reset()
            VisualizationProvider.getVariableVisualization(id).then((data) => {
                commit(SET_DATA_CONSENSUS_VARIABLE, data.data.variable);
            })
        }
    },
    mutations: {
        [SET_CONTRIES_VISUALIZATION](state, data) {
            state.contries_vizualization = data;
        },
        [SET_DATA_VISUALIZATION](state, data) {
            state.dataVizualization = data;
        },
        [SET_DATA_CONSENSUS_VARIABLE](state, data) {
            state.variable_Visualiztion = data;
        }

    },

}
